/* tslint:disable:max-line-length */
import { DefaultMessages, SegmentSpecificMessages } from '@sheerid/jslib';

type ExtendedMessages = {
    locales: {
        'en-AU': string,
    },
    step: {
        personalInfo: {
            title: string,
        },
        success: {
            title: string,
            subtitle: string,
            redirectTextA: string,
            redirectTextB: string,
            buttonTwo: string,
            underCoupon: string,
        },
        docUpload: {
            title: string,
            subtitle: string,
        },
    },
};

export const medicalMessagesDE: DefaultMessages & SegmentSpecificMessages & ExtendedMessages = {
    birthDate: 'Geburtsdatum',
    branchOfService: 'Dienstzweig',
    changeLanguage: 'Sprache ändern',
    optIn: 'Ich möchte Marketing-E-Mails und andere Werbemitteilungen von P.volve erhalten.',
    infoShared: 'Die Informationseingabe dient nur der Verifizierung und wird mit P.volve geteilt.',
    MedicalProfessionalInfoShared: 'Die hier eingegebenen Informationen werden zu Verifizierungszwecken verwendet.',
    country: 'Land',
    countryPlaceholder: 'Land',
    OTHER_HEALTH_WORKER: 'Andere Gesundheitspersonal',
    DOCTOR: 'Doktor',
    NURSE: 'Krankenschwester',
    countries: {
        AD: 'Andorra',
        AE: 'Vereinigte Arabische Emirate',
        AF: 'Afghanistan',
        AG: 'Antigua und Barbuda',
        AI: 'Anguilla',
        AL: 'Albanien',
        AM: 'Armenien',
        AN: 'Niederländische Antillen',
        AO: 'Angola',
        AR: 'Argentinien',
        AS: 'Amerikanisch-Samoa',
        AT: 'Österreich',
        AU: 'Australien',
        AW: 'Aruba',
        AZ: 'Aserbaidschan',
        BA: 'Bosnien-Herzegowina',
        BB: 'Barbados',
        BD: 'Bangladesch',
        BE: 'Belgien',
        BF: 'Burkina Faso',
        BG: 'Bulgarien',
        BH: 'Bahrain',
        BI: 'Burundi',
        BJ: 'Benin',
        BM: 'Bermuda',
        BN: 'Brunei Darussalam',
        BO: 'Bolivien',
        BR: 'Brasilien',
        BS: 'Bahamas',
        BT: 'Bhutan',
        BV: 'Bouvet-Insel',
        BW: 'Botswana',
        BY: 'Weißrussland',
        BZ: 'Belize',
        CA: 'Kanada (ohne Québec)',
        CF: 'Zentralafrikanische Republik',
        CG: 'Kongo',
        CH: 'Schweiz',
        CI: 'Elfenbeinküste (Cote D\'Ivoire)',
        CK: 'Cookinseln',
        CL: 'Chile',
        CM: 'Kamerun',
        CN: 'China',
        CO: 'Kolumbien',
        CR: 'Costa Rica',
        CU: 'Kuba',
        CV: 'Kap Verde',
        CY: 'Zypern',
        CZ: 'Tschechische Republik',
        DE: 'Deutschland',
        DJ: 'Dschibuti',
        DK: 'Dänemark',
        DM: 'Dominica',
        DO: 'Dominikanische Republik',
        DZ: 'Algerien',
        EC: 'Ecuador',
        EE: 'Estland',
        EG: 'Ägypten',
        EH: 'Westsahara',
        ER: 'Eritrea',
        ES: 'Spanien',
        ET: 'Äthiopien',
        FI: 'Finnland',
        FJ: 'Fidschi',
        FK: 'Falkland-Inseln',
        FM: 'Mikronesien',
        FO: 'Färöer-Inseln',
        FR: 'Frankreich',
        GA: 'Gabun',
        GB: 'Vereinigtes Königreich',
        GD: 'Grenada',
        GE: 'Georgien',
        GF: 'Französisch-Guayana',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Grönland',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe (Französisch)',
        GQ: 'Äquatorialguinea',
        GR: 'Griechenland',
        GS: 'Südgeorgien und Südliche Sandwichinseln',
        GT: 'Guatemala',
        GU: 'Guam (USA)',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HK: 'Hongkong',
        HM: 'Heard und McDonaldinseln',
        HN: 'Honduras',
        HR: 'Kroatien',
        HT: 'Haiti',
        HU: 'Ungarn',
        ID: 'Indonesien',
        IE: 'Irland',
        IL: 'Israel',
        IN: 'Indien',
        IO: 'Britisches Territorium im Indischen Ozean',
        IQ: 'Irak',
        IR: 'Iran',
        IS: 'Island',
        IT: 'Italien',
        JM: 'Jamaika',
        JO: 'Jordanien',
        JP: 'Japan',
        KE: 'Kenia',
        KG: 'Kirgisistan',
        KH: 'Kambodscha',
        KI: 'Kiribati',
        KM: 'Komoren',
        KN: 'St. Kitts und Nevis Anguilla',
        KP: 'Nordkorea',
        KR: 'Südkorea',
        KW: 'Kuwait',
        KY: 'Kaimaninseln',
        KZ: 'Kasachstan',
        LA: 'Laos',
        LB: 'Libanon',
        LC: 'St. Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Litauen',
        LU: 'Luxemburg',
        LV: 'Lettland',
        LY: 'Libyen',
        MA: 'Marokko',
        MC: 'Monaco',
        MD: 'Moldawien',
        ME: 'Montenegro',
        MG: 'Madagaskar',
        MH: 'Marshall-Inseln',
        MK: 'Mazedonien',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolei',
        MO: 'Macau',
        MP: 'Nördliche Marianen',
        MQ: 'Martinique (Französisch)',
        MR: 'Mauretanien',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Malediven',
        MW: 'Malawi',
        MX: 'Mexiko',
        MY: 'Malaysia',
        MZ: 'Mosambik',
        NA: 'Namibia',
        NC: 'Neukaledonien (Französisch)',
        NE: 'Niger',
        NF: 'Norfolkinsel',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Niederlande',
        NO: 'Norwegen',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Neuseeland',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Polynesien (Französisch)',
        PG: 'Papua-Neuguinea',
        PH: 'Philippinen',
        PK: 'Pakistan',
        PL: 'Polen',
        PM: 'Saint Pierre und Miquelon',
        PN: 'Insel Pitcairn',
        PR: 'Puerto Rico',
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Katar',
        RE: 'Réunion (Französisch)',
        RO: 'Rumänien',
        RS: 'Serbien',
        RU: 'Russland',
        RW: 'Ruanda',
        SA: 'Saudi-Arabien',
        SB: 'Salomon-Inseln',
        SC: 'Seychellen',
        SD: 'Sudan',
        SE: 'Schweden',
        SG: 'Singapur',
        SH: 'St. Helena',
        SI: 'Slowenien',
        SK: 'Slowakische Republik',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Suriname',
        ST: 'São Tomé (Sao Tome) und Príncipe',
        SV: 'El Salvador',
        SY: 'Syrien',
        SZ: 'Swasiland',
        TC: 'Turks- und Caicosinseln',
        TD: 'Tschad',
        TF: 'Französische Südterritorien',
        TG: 'Togo',
        TH: 'Thailand',
        TJ: 'Tadschikistan',
        TK: 'Tokelau',
        TM: 'Turkmenistan',
        TN: 'Tunesien',
        TO: 'Tonga',
        TR: 'Türkei',
        TT: 'Trinidad und Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tansania',
        UA: 'Ukraine',
        UG: 'Uganda',
        UM: 'Kleinere abgelegene Inseln der USA',
        US: 'Vereinigte Staaten von Amerika',
        UY: 'Uruguay',
        UZ: 'Usbekistan',
        VA: 'Vatikanstadt',
        VC: 'St. Vincent und die Grenadinen',
        VE: 'Venezuela',
        VG: 'Jungferninseln (Britisch)',
        VI: 'Jungferninseln (USA)',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis und Futuna-Inseln',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Jemen',
        YT: 'Mayotte',
        ZA: 'Südafrika',
        ZM: 'Sambia',
        ZW: 'Simbabwe',
    },
    dateTime: {
        january: 'Januar',
        february: 'Februar',
        march: 'März',
        april: 'April',
        may: 'Mai',
        june: 'Juni',
        july: 'Juli',
        august: 'August',
        september: 'September',
        october: 'Oktober',
        november: 'November',
        december: 'Dezember',
        month: 'Monat',
        day: 'Tag',
        year: 'Jahr',
        '2_MIN': '2 Minuten',
        '20_MIN': '20 Minuten',
        '2_HOURS': '2 Stunden',
        '24_HOURS': '24 Stunden',
        '3_DAY': '3 Tage',
        A_FEW_MINUTES: 'ein paar Minuten',
        A_FEW_HOURS: 'ein paar Stunden',
        A_FEW_DAYS: 'ein paar Tage',
    },
    dischargeDate: 'Entlassungsdatum',
    emailAddress: 'E-Mail-Adresse',
    emailExplanation: 'Wird benötigt, um Ihnen Ihren eindeutigen Code zuzusenden',
    schoolName: '', // N/A
    phoneNumber: 'Handynummer',
    error: 'Fehler',
    limitExceededError: 'Verifizierungslimit überschritten',
    firstName: 'Vorname',
    howDoesReviewWork: 'Wie funktioniert die Überprüfung?',
    howDoesVerifyingWork: 'Wie funktioniert die Verifizierung?',
    informationTransferredToUS: 'Ihre Informationen werden in die Vereinigten Staaten übermittelt und gemäß den Datenschutzrichtlinien von SheerID behandelt.',
    lastName: 'Nachname',
    loading: 'Wird geladen...',
    locales: {
        'en-US': 'Englisch',
        fr: 'Französisch',
        nl: 'Niederländisch',
        'fr-CA': 'Französisch (Kanada)',
        de: 'Deutsch',
        it: 'Italienisch',
        es: 'Spanisch',
        'en-AU': 'Englisch (Australien}',
        'en-GB': 'Englisch (UK)',
        ar: 'Arabisch',
        bg: 'Bulgarisch',
        'zh-HK': 'Chinesisch (Hongkong)',
        zh: 'Chinesisch (traditionell)',
        hr: 'Kroatisch',
        cs: 'Tschechisch',
        da: 'Dänisch',
        fi: 'Finnisch',
        el: 'Griechisch',
        iw: 'Hebräisch',
        hu: 'Ungarisch',
        is: 'Isländisch',
        id: 'Indonesisch',
        ja: 'Japanisch',
        ko: 'Koreanisch',
        lt: 'Litauisch',
        ms: 'Malaiisch',
        no: 'Norwegisch',
        pl: 'Polnisch',
        'pt-BR': 'Portugiesisch (Brasilien)',
        pt: 'Portugiesisch',
        ro: 'Rumänisch',
        ru: 'Russisch',
        sr: 'Serbisch',
        sk: 'Slowakisch',
        sl: 'Slowenisch',
        'es-ES': 'Spanisch (Spanien)',
        sv: 'Schwedisch',
        tr: 'Türkisch',
    },
    militaryStatus: 'Militärischer Status',
    noOptions: 'Keine Optionen',
    personalInformation: 'Persönliche Informationen',
    personalOrSchoolIsFine: 'Persönliche oder schulische E-Mail ist in Ordnung',
    postalCode: 'Postleitzahl',
    poweredBy: 'Verifizierungsdienste unterstützt von SheerID',
    requiredFields: 'Alle Felder müssen ausgefüllt werden',
    school: 'Schule',
    sheeridFaqs: 'SheerID FAQ',
    studentInfoShared: 'Die eingegebenen Informationen dieses Webformulars dienen der Verifizierung. Sie werden an {companyName} weitergegeben.',
    universityName: 'Name der Universität',
    verifyAndContinue: 'Verifizieren und fortfahren',
    verificationPurposesOnly: 'Dient nur der Verifizierung',
    verifyMyStudentStatus: 'Meinen Studentenstatus verifizieren',
    verifyMyTeacherStatus: 'Meinen Lehrkraftstatus verifizieren',
    verifyMyMilitaryStatus: 'Meinen militärischen Status verifizieren',
    verifyMyMedicalProfessionalStatus: 'WEITER',
    verifyMyEmploymentStatus: 'Meinen Mitarbeiterstatus verifizieren',
    status: 'Status',
    statusPlaceholder: 'Status',
    VETERAN: 'Veteran',
    MILITARY_RETIREE: 'Militärischer Ruheständler',
    RESERVIST: 'Reservist',
    ACTIVE_DUTY: 'Aktiver Dienst',
    MILITARY_FAMILY: 'Registrierter Militärangehöriger',
    FIREFIGHTER: 'Feuerwehrmann',
    POLICE: 'Polizist',
    EMT: 'Rettungssanitäter',
    organization: 'Organisation',
    verifyMyFirstResponderStatus: 'Meinen Ersthelfer-Status verifizieren',
    firstResponderInfoShared: 'Diese Dateneingabe dient der Verifizierung',
    militaryInfoShared: 'Diese Dateneingabe dient der Verifizierung',
    tryAgain: 'Nochmal versuchen',
    errorId: {
        internalServerError: 'Interner Serverfehler',
        noProgram: 'Kein Programm gefunden',
        noVerification: 'Keine Verifizierung gefunden',
        expiredProgram: 'Dieser Link ist nicht mehr aktiv',
        invalidProgram: 'Ungültiges Programm',
        invalidStep: 'Ungültiger Schritt',
        invalidMilitaryStatus: 'Ungültiger militärischer Status',
        invalidFirstResponderStatus: 'Ungültiger Ersthelfer-Status',
        invalidOrganization: 'Sie müssen eine Organisation aus der Liste wählen',
        invalidFirstName: 'Ungültiger Vorname',
        invalidLastName: 'Ungültiger Nachname',
        invalidBirthDate: 'Ungültiges Geburtsdatum',
        invalidEmail: 'Ungültige E-Mail',
        invalidPhoneNumber: 'Ungültige Handynummer',
        invalidPostalCode: 'Ungültige Postleitzahl',
        invalidAddress: 'Ungültige Adresse',
        invalidCity: 'Ungültige Stadt',
        invalidState: 'Ungültiges Land',
        underagePerson: 'Personen unter 16 Jahren haben keinen Anspruch auf dieses Angebot.',
        noRemainingRewardCodes: 'Leider ist dieses Angebot geschlossen und der Benutzer momentan nicht verifizierbar. Bitte versuchen Sie es später noch einmal.',
        outsideAgePerson: 'Alter außerhalb des zulässigen Bereichs',
        futureBirthDate: 'Zukünftiges Geburtsdatum',
        unsupportedDocMimeType: 'Format einer (oder mehrerer) Datei(en) wird nicht unterstützt',
        invalidFileSizeEmpty: 'Mindestens eine Datei ist leer',
        invalidFileSizeMax: 'Mindestens eine Datei ist zu groß (max. 10 MB)',
        invalidNumberOfFiles: 'Maximale Anzahl Dateien überschritten (max. 5)',
        invalidDocUploadToken: 'Das bereitgestellte Upload-Token des Dokuments ist ungültig',
        verificationLimitExceeded: 'Ihr Elan ist erfreulich, scheinbar haben Sie dieses Angebot aber bereits eingelöst oder es schon einmal versucht.',
        fraudRulesReject: 'Ihr Elan ist erfreulich, scheinbar haben Sie dieses Angebot aber bereits eingelöst oder es schon einmal versucht.',
        apiRateLimitExceeded: 'Wir können Ihre Anfrage zurzeit nicht verarbeiten, bitte versuchen Sie es später noch einmal',
        docReviewLimitExceeded: 'Limit für Dokumentenprüfung überschritten',
        maxMetadataValuesExceeded: 'Maximale Anzahl von Metadatenwerte überschritten',
        maxMetadataLengthExceeded: 'Maximale Länge des Metadatenwertes überschritten',
        unknownError: 'Unbekannter Fehler',
        invalidRequest: 'Ungültige Anfrage',
        invalidApiToken: 'Das bereitgestellte API-Token ist ungültig oder leer',
        simulatedError: 'Dies ist ein simulierter Fehler',
        notFound: 'Nicht gefunden',
        unauthorizedDomain: 'Nicht autorisierte Domäne',
        invalidCountry: 'Ungültiges Land',
        invalidMemberId: 'Ungültige Identifikationsnummer',
    },
    step: {
        personalInfo: {
            title: 'IHRE ANGABEN ÜBERPRÜFEN',
            subtitle: 'Wenn Sie eine lizenzierte medizinische Fachkraft sind, füllen Sie bitte das nachstehende Formular aus.',
            howDoesVerifyingWorkDetails: `Um sich für dieses Angebot zu qualifizieren, müssen Sie (1) eine in den USA lizenzierte medizinische Fachkraft
                    und (2) Mitglied eines berechtigten ärztlichen Berufszweigs sein. Die berechtigten Berufszweige werden in der Statusauswahl
                    dieses Formulars angezeigt.<br><br>{company} überprüft Ihren Status als medizinische Fachkraft mithilfe seines vertrauenswürdigen Partners SheerID.
                    SheerID sammelt nur Informationen, die zur Überprüfung Ihrer Berechtigung hilfreich sind.
                    Zusätzliche Informationen oder Unterlagen können angefordert werden.`,
            tryAgain: {
                title: 'Überprüfen Sie Ihren Namen, Postleitzahl, Geburtsdatum und Organisation',
                subtitle: 'Ihr vollständiger Name, der Name Ihrer Organisation, Ihre Postleitzahl und Ihr Geburtsdatum müssen mit den Angaben Ihrer Lizenzierungsstelle übereinstimmen.',
            },
        },
        docUpload: {
            title: 'DOKUMENTATION HOCHLADEN',
            subtitle: 'Die Dokumente werden in wenigen Minuten von den Mitarbeitern von SheerID, einem vertrauenswürdigen Partner, überprüft.',
            acceptableUploadExamples: 'Akzeptable Beispiele sind:',
            acceptedTypes: 'Zulässige Dateiformate sind .jpg .jpeg .png .pdf .gif oder .bmp',
            addFile: 'Datei hinzufügen',
            cancelButtonLabel: 'Abbrechen',
            fileInstructions: 'Drag &amp; legen Sie Ihre Dateien hier ab oder <span class="sid-dropzone-wrap--link">browse</span>',
            footer: '',
            submitButtonLabel: 'Weiter',
            rejectedSubtitle: 'Wir konnten Ihre Berechtigung nicht bestätigen. Grund:',
            howDoesVerifyingWorkDetails: `Die Überprüfung der Dokumente wird von SheerID durchgeführt, einem vertrauenswürdigen Partner, der sich auf die Verifizierung von
                    medizinischen Fachkräften spezialisiert.<br><br>Dokumente dienen nur der Überprüfung Ihres aktuellen medizinischen Berufsstatus
                    und werden danach endgültig gelöscht. Sie werden nicht an {companyName} weitergegeben.`,
            uploadInstructions: 'Laden Sie ein offizielles Dokument hoch, das Folgendes zeigt:',
            rejectionReasons: {
                DOCUMENT_UNREADABLE: 'Ihr übermitteltes Dokument war aufgrund der schlechten Bildqualität nicht lesbar. Bitte stellen Sie sicher, dass das Bild deutlich lesbar (hell und scharf) ist, und versuchen Sie es erneut.',
                DOCUMENT_PASSWORD_PROTECTED: 'Wir können keine passwortgeschützten Dokumente akzeptieren.',
                DOCUMENT_LIKELY_FRAUD: 'Ihr übermitteltes Dokument reicht nicht aus, um die Berechtigung für dieses Angebot festzustellen.',
                DOCUMENT_UNSUPPORTED: 'Ihr übermitteltes Dokument ist nicht auf der Liste akzeptierter Dokumenttypen aufgeführt.',
                DOCUMENT_HANDWRITTEN: 'Wir können keine handschriftlichen Dokumente akzeptieren.',
                MISSING_INFORMATION: 'Ihr übermitteltes Dokument enthält nicht alle erforderlichen Informationen, um die Berechtigung für dieses Angebot zu bestätigen.',
                MISSING_INFORMATION_PERSON_NAME: 'In Ihrem übermittelten Dokument fehlt ein Vor- und/oder Nachname.',
                MISSING_INFORMATION_ORGANIZATION_NAME: 'Ihr übermitteltes Dokument enthält keinen Organisationsnamen, der Ihre Verbindung zu dieser Organisation bestätigt.',
                DOCUMENT_EXPIRED: 'Ihr übermitteltes Dokument ist abgelaufen.',
                DOCUMENT_OUTDATED: 'In Ihrem übermittelten Dokument fehlt ein Ausstellungsdatum oder dieses liegt zu weit zurück.',
                MISMATCH_PERSON_NAME: 'Die Informationen auf Ihrem übermittelten Dokument stimmen nicht mit dem Vor- und/oder Nachnamen Ihres Verifizierungsformulars überein.',
                MISMATCH_ORGANIZATION: 'Der Organisationsname auf Ihren übermittelten Dokumenten stimmt nicht mit der Organisation Ihres Verifizierungsformular überein.',
                MISMATCH_STATUS: 'Der Status auf Ihrem übermittelten Dokument stimmt nicht mit dem Status Ihres Verifizierungsformulars überein.',
                INELIGIBLE_ORGANIZATION: 'Die Organisation auf Ihrem übermittelten Dokument kommt für dieses Angebot nicht in Frage.',
                MISSING_INFORMATION_UNIVERSITY_ENROLLMENT: 'Ihr übermitteltes Dokument belegt nicht die Einschreibung im laufenden Semester.',
                INELIGIBLE_PERSON_HIGH_SCHOOL_STUDENT: 'Hochschüler kommen für dieses Angebot nicht in Frage.',
                MISSING_INFORMATION_AFFILIATION_US_ARMED_FORCES: 'Ihr übermitteltes Dokument ist kein Beleg für die Zugehörigkeit zu einer berechtigten Abteilung der US-Streitkräfte.',
                MISMATCH_COMPANY_NAME_OR_ADDRESS: 'Der Firmenname oder die Adresse auf Ihrem Dokument und dem Verifizierungsformular stimmen nicht überein.',
                PAYSTUB_OUTDATED_LAST_30_DAYS: 'Bitte laden Sie eine Lohnabrechnung hoch, die innerhalb der letzten 30 Tage ausgestellt wurde.',
                MISSING_INFORMATION_BIRTHDATE: 'In Ihrem übermittelten Dokument fehlt das Geburtsdatum, oder das Angebot gilt nicht für Ihr Alter.',
                MISMATCH_BIRTHDATE: 'Das Geburtsdatum auf Ihrem übermittelten Dokument stimmt nicht mit demjenigen des Verifizierungsformulars überein.',
                DOCUMENT_OUTDATED_FACULTY: 'Ihr übermitteltes Dokument belegt keine Beschäftigung im laufenden akademischen Jahr.',
                MISSING_OR_MISMATCH_JOB_TITLE: 'Die Stellenbezeichnung auf Ihrem übermittelten Dokument fehlt oder stimmt nicht mit dem Verifizierungsformular überein.',
                OTHER_CONTACT_US: 'Bei der Überprüfung Ihrer Berechtigung für das Angebot gab es ein Problem. Wenden Sie sich bitte an den SheerID Kundendienst, um Hilfe zu erhalten: customerservice@sheerid.com',
                PERSON_FIELD_MISMATCH: 'Ein Feld in dem übermittelten Dokument stimmt nicht mit den Angaben auf dem Verifizierungsformular überein.',
            },
            uploadInfo: {
                fullName: 'Ihr voller Name',
                student: {
                    enrollmentDate: 'Datum der Immatrikulationsbescheinigung für das laufende Semester (oder innerhalb der letzten 3 Monate)',
                    school: 'Ihre Schule',
                },
                teacher: {
                    currentSchoolYear: 'Ein Datum im laufenden Schuljahr',
                    school: 'Ihre Schule',
                },
                military: {
                    currentAffiliation: 'Ihre derzeitige Zugehörigkeit zu den Streitkräften',
                    dischargeDate: 'Ihr Entlassungsdatum (falls zutreffend)',
                    serviceBranch: 'Ihr Dienstzweig',
                    uploadInstructionsDependent: 'Bitte laden Sie ein Dokument hoch, aus dem Ihr Vorname, Nachname, gültige Daten und Ihr Status deutlich hervorgehen',
                },
                age: {
                    birthDate: 'Ihr Geburtsdatum',
                },
                senior: {
                    birthDate: 'Ihr Geburtsdatum',
                },
                firstResponder: {
                    currentAffiliation: 'Ihre derzeitige Zugehörigkeit zu dieser Organisation',
                    organization: 'Ihre Organisation',
                },
                medical: {
                    status: 'Ihr medizinischer Berufsstatus',
                    validDate: 'Ein derzeit gültiges Datum',
                },
                employment: {
                    company: 'Ihr Unternehmen',
                    currentAffiliation: 'Ihre derzeitige Zugehörigkeit zu diesem Unternehmen',
                },
            },
            acceptableUploads: {
                student: {
                    idCard: 'Schulausweis mit Ablaufdatum',
                    classSchedule: 'Stundenplan',
                    tuitionReceipt: 'Schulgeldquittung',
                },
                teacher: {
                    idCard: 'Lehrkraftausweis mit Gültigkeitsdatum',
                    payStub: 'Lohnabrechnung der letzten 60 Tage',
                },
                senior: {
                    birthCertificate: 'Ihre Geburtsurkunde',
                    driversLicense: 'Ihr Führerschein',
                    passport: 'Ihr Reisepass',
                    stateId: 'Ihr vom Staat ausgestellter Personalausweis',
                },
                military: {
                    activeDuty: 'Jedes Dokument, das beweist, dass Sie derzeit 30 Tage oder länger dienen gemäß Artikel 10 Aktiver Dienst',
                    veteran: 'Jedes Dokument, das beweist, dass Sie die Voraussetzungen für den Militärdienst erfüllt haben und ehrenhaft entlassen wurden',
                    reservistA: 'Jedes Dokument, aus dem hervorgeht, dass Sie derzeit in der Nationalgarde oder einer Reservekomponente der Streitkräfte der Vereinigten Staaten dienen',
                    retiree: 'Jedes Dokument, das beweist, dass Sie ein Rentner der US-Streitkräfte sind',
                    dependent: 'Jedes Dokument, das beweist, dass Sie ein registrierter militärischer Angehöriger sind',
                },
                medical: {
                    licenseCertificate: 'Lizenzbescheinigung',
                    idCard: 'Krankenpflegeausweis mit Ablaufdatum',
                    photoPayStub: 'Lichtbildausweis und aktuelle Lohnabrechnung',
                },
                employment: {
                    employeeIdCard: 'Mitarbeiterausweis',
                    payStub: 'Lohnabrechnung der letzten 60 Tage',
                    officialLetter: 'Ein offizieller Brief',
                },
            },
        },
        pending: {
            titleCountdown: 'WIRD VERARBEITET',
            titleReview: 'WIRD VERARBEITET',
            subtitleCountdown: '',
            subtitle: 'SheerID überprüft Ihre Dokumente, um Ihren Status zu bestätigen. Dieser Vorgang kann bis zu 20 Minuten dauern.',
            subtitle2: 'Warten Sie hier oder lassen Sie sich von uns über das Ergebnis informieren.',
            subtitle3: 'Sie werden per E-Mail kontaktiert.',
        },
        success: {
            title: 'ERFOLG',
            subtitle: 'Sie wurden überprüft. Unten finden Sie Ihren Prämiencode, der sofort eingelöst werden kann.',
            copyCouponCode: 'Gutscheincode kopieren',
            underCoupon: 'Bitte verwenden Sie unten diesen Code für alle exklusiven Angebote.',
            emailNotification: 'Wir haben Ihnen eine Kopie per E-Mail zugesandt, damit Sie Ihren neuen Code jetzt oder später verwenden können. Sehen Sie im Postfach nach der E-Mail von verify@sheerid.com.',
            verificationOnly: `
            'Um sicherzustellen, dass Sie alle Möglichkeiten haben, Ihren Rabatt zu nutzen, senden wir Ihnen auch eine Kopie Ihres Codes und einen Link zur P.volve-Website per E-Mail, damit Sie jetzt oder später einkaufen können. Sehen Sie im Postfach nach einer E-Mail von uns (verify@sheerid.com), um alle Details zu erfahren.
            `,
            redirectTextA: 'Um sicherzustellen, dass Sie jede Gelegenheit haben, Ihren Rabatt zu nutzen, schicken wir Ihnen auch eine Kopie Ihres Codes und einen Link zur P.volve-Website per E-Mail, damit Sie jetzt oder später einkaufen können. Sehen Sie im Postfach nach einer E-Mail von uns (verify@sheerid.com), um alle Details zu erfahren.',
            redirectTextB: 'Sie sind bereits ein Streaming-Mitglied? Folgen Sie einfach den gleichen Schritten, um sich für das ermäßigte Abonnement anzumelden, und wir werden Ihr bestehendes Abonnement automatisch kündigen.',
            buttonTwo: 'AUSRÜSTUNG + STREAMING – 20% RABATT BEI BESTELLUNG',
        },
        sso: {
            title: 'Verifizierungsmethode wählen',
            subtitle: 'Zur Überprüfung Ihres Anspruchs auf dieses spezielle Studentenangebot sind weitere Angaben erforderlich. Verifizieren Sie sich mit dem Single Sign-On Ihrer Universität oder laden Sie ein qualifizierendes Dokument zur Überprüfung hoch.',
            subtitle2: '',
            cancel: '',
            login: 'Mit Single Sign-On verifizieren',
        },
    },
};
